<template>
  <div id="CityAreas">
    <div v-if="spinning">
      <van-loading type="spinner" color="#1989fa" />
    </div>
    <div v-else class="fx mt5 panel">
      <div class="dropdown f14" @click="openAreasPanel('Province')">
        {{ _truncature(currnetArea.Province?currnetArea.Province:'省',8) }}
        <van-icon v-if="!disabled" name="arrow-down" size="12" />
      </div>
      <div class="dropdown ml20 f14" @click="openAreasPanel('City')">
        {{ _truncature(currnetArea.City?currnetArea.City:'市',8) }}
        <van-icon v-if="!disabled" name="arrow-down" size="12" />
      </div>
      <div class="dropdown ml20 f14" @click="openAreasPanel('County')">
        {{ _truncature(currnetArea.County?currnetArea.County:'区县',8) }}
        <van-icon v-if="!disabled" name="arrow-down" size="12" />
      </div>
      <div v-if="showAreasPanel" class="AreasPanel" @mouseleave="()=>{showAreasPanel=false}">
        <div v-if="loading" class="loading">
          <van-loading type="spinner" color="#1989fa" />
        </div>
        <div v-else>
          <template v-if="currnetKey == 'Province'">
            <div v-for="(op,i) in options" :key="i" class="item f16" @click="select(op)">
              <span :class="op.Province == currnetArea.Province ? 'c0F6EEA fw600' :''">
                {{ op.Province }}</span>
            </div>
          </template>
          <template v-if="currnetKey == 'City'">
            <div v-for="(op,i) in city_options" :key="i" class="item f16" @click="select(op)"> <span
              :class="op.City == currnetArea.City ? 'c0F6EEA fw600' :''"
            > {{ op.City }}</span>
            </div>
          </template>
          <template v-if="currnetKey == 'County'">
            <div v-for="(op,i) in county_options" :key="i" class="item f16" @click="select(op)"> <span
              :class="op.County == currnetArea.County ? 'c0F6EEA fw600' :''"
            >
              {{ op.County }}</span></div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BaseMixin } from '@/mixins/BaseMixin'
export default {
  name: 'CityAreasControl',
  mixins: [BaseMixin],
  props: {
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      currnetArea: {},
      currnetKey: '',
      loading: false,
      spinning: false,
      showAreasPanel: false,
      params: { pageindex: 1, pagesize: 9999 },
      alloptions: [],
      options: [],
      city_options: [],
      county_options: [],
      url: '/api_basedata/Areas/List'
    }
  },
  mounted() {

  },
  created() {

  },
  methods: {
    // 显示区域面板
    openAreasPanel(key) {
      if (!this.disabled) {
        this.showAreasPanel = true
        this.currnetKey = key
      }
    },
    // 选值
    select(option) {
      console.log(option)
      this.currnetArea = option
      this.$emit('change', option)
      const data = this.alloptions
      switch (this.currnetKey) {
        case 'Province':
          this.city_options = data.filter(itm => itm.Level == 2 && itm.ProvinceCode == this.currnetArea.ProvinceCode)
          break
        case 'City':
          this.county_options = data.filter(itm => itm.Level == 3 && itm.CityCode == this.currnetArea.CityCode)
          break
      }
      this.showAreasPanel = false
    },
    // 加载数据
    async initData(areaId) {
      this.loading = true
      this.spinning = true
      const res = await this.getAction(this.url, this.params)
      this.loading = false
      this.spinning = false
      if (res.IsSuccess) {
        if (res.Data) {
          const data = res.Data
          this.alloptions = data
          if (areaId) {
            const area = data.filter(itm => itm.Id == areaId)[0]
            if (area) {
              this.currnetArea = area
              this.options = data.filter(itm => itm.Level == 1)
              this.city_options = data.filter(itm => itm.Level == 2 && itm.ProvinceCode == this.currnetArea.ProvinceCode)
              this.county_options = data.filter(itm => itm.Level == 3 && itm.CityCode == this.currnetArea.CityCode)
            }
          } else {
            this.options = data.filter(itm => itm.Level == 1)
            this.city_options = data.filter(itm => itm.Level == 2)
            this.county_options = data.filter(itm => itm.Level == 3)
          }
        }
        this.$forceUpdate()
      }
    }
  }
}
</script>

<style lang="less">
  #CityAreas {
    position: relative;
    height: 40px;

    .dropdown {
      width: 150px;
      text-align: left;
      cursor: pointer;
    }

    .hover {
      &:hover {
        color: #0F6EE9;
      }
    }

    .panel {
      padding-top: 6px;
    }

    .AreasPanel {
      position: absolute;
      top: 30px;
      z-index: 999;
      overflow-x: hidden;
      overflow-y: auto;
      border: 1px solid rgba(229, 229, 229, 1);
      border-radius: 2px;
      padding: 10px 15px;
      width: 300px;
      min-height: 200px;
      max-height: 300px;
      text-align: left;
      background-color: #FFFFFF;
      box-shadow: 0 0 0 1px rgba(229, 229, 229, 1);

      .item {
        margin-bottom: 10px;
        border-bottom: 1px solid #EEEEEE;
        padding-bottom: 10px;
        cursor: pointer;

        &:hover {
          color: #0F6EE9;
        }

        &:last-child {
          border-bottom: none;
        }
      }

      .loading {
        text-align: center;
        line-height: 200px;
      }
    }
  }
</style>
